enum ModelFileMimeTypeEnum {
    WORD = 'word',
    PDF = 'pdf'
}

export default ModelFileMimeTypeEnum
